import { BrandMark } from '../components/BrandMark';

const legalContent = {
  '/privacy': {
    title: 'Kebijakan Privasi',
    intro:
      'SenoSkripsi memproses data akun dan proyek untuk menyediakan ruang kerja akademik privat.',
    sections: [
      [
        'Data yang diproses',
        'Data akun, struktur proyek, dokumen, file, telemetry penggunaan, pembayaran, dan log keamanan diproses sesuai fungsi layanan. Isi privat tidak digunakan admin tanpa support grant eksplisit.'
      ],
      [
        'Pemroses pihak ketiga',
        'Cloudflare menyediakan runtime, database, dan penyimpanan. Midtrans memproses pembayaran. Provider AI, scholarly, PDF, dan malware scanner hanya menerima data yang diperlukan untuk task terkait.'
      ],
      [
        'Retensi dan penghapusan',
        'Project aktif disimpan selama akun menggunakan layanan. Project kadaluarsa memasuki read/download window, lalu dapat diarsipkan. Trash berbeda dari penghapusan permanen; backup dipurge mengikuti jadwal operasional.'
      ],
      [
        'Hak pengguna',
        'Pengguna dapat mengekspor metadata dan isi proyeknya, mencabut sesi, menarik support grant, dan mengajukan penghapusan akun atau proyek.'
      ]
    ]
  },
  '/terms': {
    title: 'Ketentuan Layanan',
    intro:
      'SenoSkripsi adalah ruang kerja penyusunan akademik dan bukan pengganti keputusan pengguna, dosen, kampus, atau penerbit.',
    sections: [
      [
        'Tanggung jawab akademik',
        'Pengguna wajib memeriksa fakta, sumber, hasil penelitian, sitasi, dan kepatuhan terhadap pedoman kampus. Layanan tidak menjamin kelulusan, skor similarity, atau penerimaan publikasi.'
      ],
      [
        'Penggunaan yang dapat diterima',
        'Dilarang memakai layanan untuk memalsukan data, sumber, identitas, atau hasil penelitian; menyerang sistem; menyebarkan malware; atau mengakses data pengguna lain.'
      ],
      [
        'Lisensi per proyek',
        'Setiap lisensi berlaku untuk ruang proyek yang ditentukan. Paket Skripsi mencakup satu penelitian utama dan satu artikel turunannya; Paket Jurnal mencakup satu artikel jurnal mandiri.'
      ],
      [
        'Ketersediaan',
        'Fungsi yang bergantung pada provider eksternal dapat mengalami gangguan. Draft tersimpan dan fungsi non-AI tetap dipertahankan sejauh tersedia.'
      ]
    ]
  },
  '/ai-disclosure': {
    title: 'Pengungkapan AI dan Tanggung Jawab Akademik',
    intro:
      'Seno AI mengusulkan bahasa dan struktur melalui alur Generate, Validate, Preview, lalu Apply.',
    sections: [
      [
        'Batas AI',
        'AI tidak menjadi sumber kebenaran untuk fakta penelitian, evidence, sumber, format, atau numbering. Protected Facts, Terminology Lock, Citation Lock, dan Evidence Lock tetap mengendalikan kandidat.'
      ],
      [
        'Persetujuan pengguna',
        'Kandidat tidak menimpa dokumen sebelum ditinjau dan diterapkan. Pengguna bertanggung jawab atas versi yang dipilih untuk diserahkan.'
      ],
      [
        'Originality',
        'Originality Review membantu kualitas parafrase, repetisi, dan sitasi. Fitur ini bukan alat bypass Turnitin dan tidak menjanjikan skor tertentu.'
      ]
    ]
  },
  '/refund-policy': {
    title: 'Kebijakan Pembayaran dan Refund',
    intro:
      'Pembayaran diproses melalui Midtrans dan entitlement aktif hanya setelah webhook server tervalidasi.',
    sections: [
      [
        'Status pembayaran',
        'Callback browser bukan bukti pembayaran. Status pending, settlement, expire, cancel, dan refund direkonsiliasi dari webhook yang ditandatangani.'
      ],
      [
        'Refund',
        'Permohonan refund ditinjau sesuai hukum yang berlaku, masa penggunaan, dan kondisi layanan. Refund yang disetujui dapat mencabut atau menyesuaikan entitlement dan selalu dicatat pada audit.'
      ],
      [
        'Kapasitas AI',
        'Paket memakai fair-use terkelola tanpa saldo kredit dan tanpa top-up. Kegagalan provider tidak menghabiskan reservasi penggunaan.'
      ]
    ]
  }
} as const;

export function LegalPage({
  path,
  navigate
}: {
  path: keyof typeof legalContent;
  navigate: (path: string) => void;
}) {
  const content = legalContent[path];
  return (
    <div className="legal-page">
      <header className="dashboard-header">
        <button className="brand-button" onClick={() => navigate('/')}>
          <BrandMark />
        </button>
        <button className="button button-secondary" onClick={() => navigate('/app')}>
          Kembali
        </button>
      </header>
      <main className="legal-main">
        <span className="eyebrow">SenoSkripsi V1</span>
        <h1>{content.title}</h1>
        <p className="legal-intro">{content.intro}</p>
        {content.sections.map(([title, body]) => (
          <section key={title}>
            <h2>{title}</h2>
            <p>{body}</p>
          </section>
        ))}
        <p className="legal-version">Versi 1.0 · berlaku mulai 23 September 2026</p>
      </main>
    </div>
  );
}
